import { post } from '@webapp-next/lib/request/webapp/apiv2';

export async function subscribeToAddOn(
  addOnID,
  isTrial = false,
  promoCode = ''
) {
  const payload = {
    productIdentifier: addOnID,
    isTrial,
  };

  if (promoCode) {
    payload.promoCode = promoCode;
  }

  return await post('/api/v2/subscriptions/product/add-on', payload);
}
